import { useEffect } from 'react';

export default function useNoIndex() {
    useEffect(() => {
        let meta = document.querySelector("meta[name='robots']");
        if (!meta) {
            meta = document.createElement('meta');
            meta.name = 'robots';
            document.head.appendChild(meta);
        }
        meta.content = 'noindex, nofollow';
        return () => { meta.content = 'index, follow'; };
    }, []);
}
